/* eslint-disable */
var $ = window.jQuery = require('jquery');
import toast from '../../../services/toast';
import { mapGetters } from 'vuex';
var $ = window.jQuery = require('jquery');
export default {
  name: 'public-quiz-question-answer',
  components: {
  },
  props: [],
  data() {
    return {
      QuizList:null,
      quizDetailsEdit:null,
      editQuizQueAns:null,
      quizData:{
        quizId:''
      },
      coursesId:'',
      submitted:false,
      quizQuesList:'',
      removeQuizQueId:'',
      renderEq:true,
      pub_catID:'',
    }
  },
  computed: {
    ...mapGetters([
      'getQuizDetailsByIdDataState'
    ]),
    getQuizQuesList() {
      this.quizQuesList = this.$store.getters.getQuizDetailsByIdDataState;
      if(this.$route.hash) {
        this.scrollFix(this.$route.hash);
      }
      return this.quizQuesList
    },
  },
  mounted() {
    this.pub_catID = this.$route.params.quiz_catId,
    this.quizData.quizId = this.$route.params.quizId;
    this.renderMathJax()
    this.renderMathJaxAgainFun()
    setInterval(()=>{
      this.renderMathJaxAgainFun()
    },500)
  },
  methods: {
    scrollFix: function(hash) {
      setTimeout(() => jQuery('html, body').animate({
        scrollTop: jQuery(hash).offset().top - 80
      }, 100), 10)
    },
    renderMathJax(){
      setTimeout(()=>{
        this.renderEq = false
      }, 1000)
    },
    renderMathJaxAgainFun(){
        if(window.MathJax){
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => console.log());
        }
    },
    getQuizQuesListAgain() {
      this.$store.dispatch('getQuizDetailsByIdFun', {
        id: this.$route.params.quizId
      }).then((res) => {
        this.quizQuesList = this.$store.getters.getQuizDetailsByIdDataState
      }).catch((err) => {})
    },
    removeQuizQueagain(id){
    $('#removQuizQueModalAgain').modal();
    this.removeQuizQueId = id
    },
    RemoveQuizQueConfirmationagain(){
      this.$store.dispatch('removeQuizQuesFun', {
        id: this.removeQuizQueId
      }).then((res) => {
        this.getQuizQuesListAgain()
        toast.success(res.data.msg);
      }).catch((err) => {})
    }
  },
  watch: {
    getQuizQuesList() {
      return this.$store.getters.getQuizDetailsByIdDataState
    },
  },
}
